import { getImagePath } from '../utils/imagePath';

const ErrorPage = () => {
  return (
    <div className="min-h-screen w-full max-w-[100vw] flex flex-col items-center justify-center bg-[#1a1a1a] text-white px-4 py-12 overflow-x-hidden">
      <div className="max-w-lg w-full text-center">
        {/* Stevie */}
        <div className="mb-8 flex justify-center">
          <img
            src={getImagePath('/images/pricing/stevie.jpg')}
            alt="Stevie, Chief Morale Officer"
            className="w-48 h-48 sm:w-56 sm:h-56 rounded-full object-cover border-4 border-[#9a83ad] shadow-xl"
          />
        </div>

        <h1 className="text-2xl sm:text-3xl font-serif font-bold text-[#9a83ad] mb-3">
          Oops. Someone might have unplugged the server to charge their phone.
        </h1>

        <p className="text-white/90 text-base sm:text-lg leading-relaxed mb-6">
          We&apos;re working on getting the site up and running again. Stevie (our Chief Morale Officer) is on the case—or at least staring at the router with great concern.
        </p>

        <p className="text-white/80 text-sm sm:text-base mb-8">
          In the meantime, reach out and we&apos;ll get back to you as soon as we&apos;re back online:
        </p>

        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center sm:gap-6 gap-3">
          <a
            href="mailto:info@thevbcgroup.com"
            className="inline-block text-[#9a83ad] font-semibold text-lg hover:text-[#dfc0b5] transition-colors underline underline-offset-2"
          >
            info@thevbcgroup.com
          </a>
          <a
            href="tel:8002315629"
            className="inline-block text-[#9a83ad] font-semibold text-lg hover:text-[#dfc0b5] transition-colors underline underline-offset-2"
          >
            (800) 231-5629
          </a>
        </div>

        <p className="mt-8 text-white/60 text-sm">
          Thanks for your patience. We&apos;ll be back before you can say &ldquo;good dog.&rdquo;
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
